<!-- eslint-disable no-eval -->
<template>
  <!-- the favorite heart component -->
  <div :class="containerClass">
    <!-- nice transition for when the heart changes -->
    <transition
      name="fadeLong"
      mode=""
    >
      <!-- they are not authenticated -->
      <span
        v-if="!authenticated"
        :key="1"
      >

        <!-- show a grey heart that will prompt them to sign in when it is clicked -->
        <img
          class="itemCardHeart"
          src="../assets/icon-heart.png"
          alt="Favorite"
          @click="showModal"
        >
      </span>

      <!-- an add or remove action is taking place -->
      <span
        v-else-if="authenticated && isPending"
        :key="2"
        class="loading"
      />

      <!-- they are authenticated and this item is on their favorite list -->
      <span
        v-else-if="authenticated && isFavorite"
        :key="3"
        :class="relative ? 'relative' : ''"
      >

        <!-- show a red heard that removes the item when it is clicked -->
        <img
          class="itemCardHeart"
          src="../assets/icon-heart-red.png"
          alt="Favorite"
          @click="toggleFavorite"
        >
      </span>

      <!-- they are authenticated and this item is not on their favorite list -->
      <span
        v-else-if="authenticated"
        :key="4"
        :class="relative ? 'relative' : ''"
      >

        <!-- show a red heard that add the item when it is clicked -->
        <img
          class="itemCardHeart"
          src="../assets/icon-heart.png"
          alt="Favorite"
          @click="toggleFavorite"
        >
      </span>
    </transition>
  </div>
</template>

<script>

export default {
	name: 'FavoriteHeart',
	props: [
		'item_id',
		'relative'
	],
	computed: {
		isPending: function () {
			if (
				eval('this.$store.getters.apiPending.add_favorite_' + this.item_id) ||
				eval('this.$store.getters.apiPending.remove_favorite_' + this.item_id)
			) {
				return true
			}
			return false
		},
		customer: function () {
			return this.$store.getters.customer
		},
		isFavorite: function () {
			// we have a customer favorite list id
			if (typeof this.customer.favorite_list_id !== 'undefined') {
				// we have the favorite list in the store
				if (typeof this.$store.getters.lists['LISTID_' + this.customer.favorite_list_id] !== 'undefined') {
					// the item is on the list
					if (this.$store.getters.lists['LISTID_' + this.customer.favorite_list_id].inventory_ids.find(inventoryId => inventoryId === this.item_id)) {
						// it is on the customer's favorite list
						return true
					}
				}
			}
			// it is not on the customer's favorite list
			return false
		},
		// the state of authentication
		authenticated: function () {
			return this.$store.getters.isAuthenticated
		},
		containerClass: function () {
			return this.relative ? 'favorite flexBoxCentered relative' : 'favorite flexBoxCentered'
		}
	},
	methods: {
		// show a modal
		showModal () {
			// show the sign in modal
			this.$store.dispatch('showModal', { component: 'SignIn', props: [] })
		},
		// add or remove the item from our favorite list
		toggleFavorite () {
			// we have a customer favorite list id
			if (typeof this.customer.favorite_list_id !== 'undefined') {
				// we have the favorite list in the store
				if (typeof this.$store.getters.lists['LISTID_' + this.customer.favorite_list_id] !== 'undefined') {
					// the item is on the list
					if (this.$store.getters.lists['LISTID_' + this.customer.favorite_list_id].inventory_ids.find(inventoryId => inventoryId === this.item_id)) {
						// add it to the list
						this.$store.dispatch('removeItemFromList', { inventory_id: this.item_id, list_id: this.customer.favorite_list_id, context: 'remove_favorite_' + this.item_id })
						// the item is not on the list
					} else {
						// add it to the list
						this.$store.dispatch('addItemToList', { inventory_id: this.item_id, list_id: this.customer.favorite_list_id, context: 'add_favorite_' + this.item_id })
					}
				}
			}
		}
	}
}
</script>

<style scoped>
.relative {
	position: relative !important;
	margin: 0 10px 0 5px !important;
	transform: scale(0.85);
}
</style>
